<template>
    <div class="container">
        <div class="margin-top-10">
            <div class="display-flex justify-content-space-between">
                <!-- <div class="wrap-left">
                    <h3><strong>{{ dataElectronicLecture.name }}</strong></h3>
                </div> -->
                <div class="wrap-right display-flex justify-content-space-between">
                    <a href="javascript:;"
                        class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add"
                        @click="handleCreateUpdateFile" v-if="isEdit == 1">
                        <img class="icon-plus" src="@/assets/img/plus.png" />
                        <img class="icon-plus" src="@/assets/img/plus-hover.png" />
                        Thêm tài liệu đính kèm
                    </a>
                </div>
            </div>
            <div class="list-file margin-top-10" v-if="listDataFile.length > 0">
                <div class="row item margin-top-10" v-for="(item, index) of listDataFile" :key="index">
                    <div class="col-md-4" @click="handleOnViewFile(item)">
                        <h5><strong>{{ item.name }}</strong></h5>
                        <div class="wrap-line-file display-flex justify-content-space-between">
                            <div>{{ item.fileName }}</div>
                            <div class="">
                                {{ formatSizeFile(item.sizeFile) }}
                            </div>
                        </div>

                    </div>
                    <div class="col-md-8 display-flex">
                        <button type="button" @click="handleEditName(item)"
                            class="btn btn-edit border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                            v-if="isEdit == 1">
                            Sửa tên tài liệu
                        </button>
                        <button type="button" @click="handleDeleteFile(item)"
                            class="btn btn-delete border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                            v-if="isEdit == 1">
                            Xóa tài liệu
                        </button>
                    </div>
                </div>

            </div>
            <div class="text-center" v-else>Bài giảng chưa có tài liệu đính kèm</div>

        </div>
        <div class="row pagination container m-0">
            <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
        </div>
        <ModalCreateUpdateFile :type="type" :fileId="fileIdCurrent" v-if="isOpenModalCreateUpdateFile"
            @closeModal="closeModal" @handleDone="handleDone" />

        <ModelDeleteFile :fileId="fileIdCurrent" v-if="isOpenModalDeleteFile" @closeModal="closeModalDelete"
            @handleDeleteDone="handleDeleteDone" />
        <ModalViewFile v-if="isShowFile" :path="pathSelected" @closeModal="closeModalViewFile" />
    </div>
</template>
<script>
import ModalCreateUpdateFile from './ModalCreateUpdateFile'
import ModelDeleteFile from './ModelDeleteFile'
import ModalViewFile from './../../../_components/ModalViewFile'
import { listFileClassSchool } from './../../../_api/fileClassSchoolServices'
export default {
    props: {
        dataElectronicLecture: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        type: {
            type: Number,
            default: 0
        },
        isEdit: {
            type: Number,
            default: 0
        },
    },
    watch: {
        'paramQueryData.pageIndex': 'getDataFile',
        'paramQueryData.keyword': 'filterDataByKeyword'
    },
    data() {
        return {
            isLoading: false,
            isOpenModalCreateUpdateFile: false,
            paramQueryData: {
                lessonClassSchoolId: 0,
                keyword: '',
                pageIndex: 1,
                pageSize: 6,
                type: this.type
            },
            isOpenModalDeleteFile: false,
            listDataFile: [],
            totalRecords: 0,
            fileIdCurrent: 0,
            isShowFile: false,
            pathSelected: '',
        }
    },
    components: {
        ModalCreateUpdateFile,
        ModelDeleteFile,
        ModalViewFile
    },
    mounted() {
        this.paramQueryData.lessonClassSchoolId = this.$route.query.id
        this.getDataFile()
    },
    methods: {
        handleOnViewFile(file) {
            this.isShowFile = true
            this.pathSelected = file.path
        },
        closeModalDelete() {
            this.isOpenModalDeleteFile = false
        },
        closeModalViewFile() {
            this.isShowFile = false
        },
        handleDeleteDone() {
            this.getDataFile()
            this.closeModalDelete()
        },
        handleDone() {
            this.getDataFile()
            this.closeModal()
        },
        closeModal() {
            this.isOpenModalCreateUpdateFile = false
        },
        handleCreateUpdateFile() {
            this.fileIdCurrent = 0
            this.isOpenModalCreateUpdateFile = true
        },
        handleEditName(item) {
            this.fileIdCurrent = item.id
            this.isOpenModalCreateUpdateFile = true
        },
        handleDeleteFile(item) {
            this.fileIdCurrent = item.id
            this.isOpenModalDeleteFile = true
        },
        filterDataByKeyword() {
            this.paramQueryData.pageIndex = 1
            this.getDataFile()
        },
        formatSizeFile(data, to = 'MB') {
            const const_term = 1024;

            // Convert the values and concatenate 
            // the appropriate unit 
            if (to === "KB") {
                return (data / const_term).toFixed(3) + "KB";
            } else if (to === "MB") {
                return (data / const_term ** 2).toFixed(3) + "MB";
            } else if (to === "GB") {
                return (data / const_term ** 3).toFixed(3) + "GB";
            } else if (to === "TB") {
                return (data / const_term ** 4).toFixed(3) + "TB";
            } else {
                return "";
            }
        },
        getDataFile() {
            let self = this
            listFileClassSchool(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataFile = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        }
    }

}
</script>
<style lang="scss" scoped>
.margin-top-10 {
    margin-top: 10px;
}


.justify-content-space-between {
    justify-content: space-between;
}

.icon-plus {
    width: 20px;
    top: 0px !important;
    display: inline-block;
}

.btn-delete {
    background-color: red;
    color: white;
    margin-left: 5px;
}

.btn-edit {
    background-color: #7ea8c7;
    color: rgb(70, 69, 69);
    margin-left: 5px;
}
</style>